import ChatbotModal from 'components/ChatBot/ChatbotModal';
import Header from 'components/ui/Header';
import Sidebar from 'components/ui/Sidebar';
import { DataContext } from 'context/DataContext';
import { useState, useEffect, useContext } from 'react';
import { BiSupport } from 'react-icons/bi';
// import { GitBookProvider, GitBookAssistantFrame } from '@gitbook/embed/react';


import { Link, Outlet } from 'react-router-dom';
// import { DataContext } from '../contexts/DataContext';
// import AnimatedBackground from '../components/AnimatedBackground';

const MainLayout = () => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false); // ✅ Mobile state
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const { fetchProfileData } = useContext(DataContext);

  useEffect(() => {
    // ensure stable callback
    const fetchRef = { current: fetchProfileData };

    const runFetch = () => {
      const lastUpdate = localStorage.getItem("lastUserDetailsUpdate");
      const now = Date.now();

      if (!lastUpdate || now - parseInt(lastUpdate, 10) >= 3600000) {
        fetchRef.current();
        localStorage.setItem("lastUserDetailsUpdate", now);
      }
    };

    runFetch();

    // set theme only once
    localStorage.setItem("theme", "dark");

    // interval
    const interval = setInterval(() => {
      fetchRef.current();
      localStorage.setItem("lastUserDetailsUpdate", Date.now());
    }, 3600000);

    return () => clearInterval(interval);

  }, [fetchProfileData]);

  useEffect(() => {
    fetchProfileData()
  }, [])

  // useEffect(() => {
  //   // Prevent duplicate injection
  //   if (window.GitBookAssistant) return;

  //   const script = document.createElement('script');
  //   script.src = "https://widgets.gitbook.com/assistant.js";
  //   script.async = true;
  //   script.defer = true;
  //   script.setAttribute("data-site", "profitsla"); // This is your space ID
  //   // Optional: customize appearance
  //   script.setAttribute("data-theme", "dark");
  //   script.setAttribute("data-position", "bottom-right");

  //   document.body.appendChild(script);

  //   return () => {
  //     // Cleanup (optional)
  //     const existing = document.querySelector('script[src="https://widgets.gitbook.com/assistant.js"]');
  //     existing?.remove();
  //   };
  // }, []);


  return (

    <div className="flex h-screen overflow-hidden starry-background">
      {/* Sidebar */}
      <Sidebar
        isCollapsed={sidebarCollapsed}
        onToggleCollapse={() => setSidebarCollapsed(!sidebarCollapsed)}
        setIsMobileOpen={setIsMobileOpen}
        isMobileOpen={isMobileOpen}
      />
      <div
        className={`flex-1 flex flex-col min-w-0 transition-all duration-300 ${sidebarCollapsed ? "lg:ml-16" : "lg:ml-72"
          }`}
      >
        <Header setIsMobileOpen={setIsMobileOpen} isMobileOpen={isMobileOpen} />
       

        <main className="flex-1 overflow-y-auto pt-16">
          <Outlet />
          <ChatbotModal onClick={openModal} isOpen={isModalOpen} onClose={closeModal} />
          </main>

          {/* <div className="">
           
            <button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={openModal}
            className={`bottom-10 right-0 z-40 fixed p-2 rounded-full shadow-neumorphic bg-neonPurple mx-2 
            } `}          >
            <BiSupport size={25} className="text-white" />
            
          </button>

          
          </div> */}
          
        {/* <button
          onClick={() => window.GitBookAssistant?.open()}
          className="fixed bottom-6 right-6 z-50 bg-blue-600 text-white rounded-full p-4 shadow-2xl hover:scale-110 transition-all"
        >
          <MessageCircle size={28} />
        </button> */}
        {/* <GitBookProvider siteURL="https://docs.profitsla.com">
    <GitBookAssistantFrame />
</GitBookProvider> */}
        {/* <Link to="https://docs.profitsla.com" target="_blank" rel="noopener noreferrer">
        <div className='flex justify-end fixed gap-1 bottom-4 right-4 z-50 cursor-pointer border items-center border-white rounded-full text-xs px-2 py-1'>
          <MessageCircle size={20} className=' text-primary cursor-pointer' />Guide
        </div>
        </Link> */}
      </div>
    </div>
  );
};

export default MainLayout;